// extracted by mini-css-extract-plugin
export default {"formNameBox":"index_formNameBox_C5ILs","formName":"index_formName_Ee0hQ","formWarning":"index_formWarning_6gAgI","formNameStart":"index_formNameStart_w2D40"};